import PreferenceModel from "../../../Global/Models/Preferences/PreferenceModel";
import ProfileModel from "./ProfileModel";

export default class DetailedProfileModel extends ProfileModel {
  public email: string | null = null;
  public phoneNumber: string | null = null;
  public phoneCountryCode: string | null = null;
  public preferences: PreferenceModel[] = null;
  public consentIds: string[] = null;
}
